namespace Solovis.Reports.DataPacks {

    export interface DataPackBannerControlOptions extends Solovis.UI.BaseControlOptions {
        bannerElement;
    }

    export class DataPackBannerControl extends Solovis.UI.BaseControl {

        private _bannerOptions: DataPackBannerControlOptions;

        constructor(options: DataPackBannerControlOptions) {
            super(options);

            this._bannerOptions = options;
          
            $(Solovis.Reports.DataPacks.DataPackSelector).bind("dataPackSelected", () => {
                this._updateDisplay();
            });
        }

        public doRender() {
            this._updateDisplay();
        }

        private _updateDisplay() {
            if (!this.container) {
                return;
            }

            let activeDataPackCode = Solovis.Reports.DataPacks.DataPackSelector.getDefaultMountCode();
            if (activeDataPackCode) {
                let contentDiv = $("<div>");
                $("<span>").text("Default Data Pack ").appendTo(contentDiv);

                var helpLink = $("<a>").appendTo(contentDiv);
                $("<span class='fa fa-question-circle'>").appendTo(helpLink);
                helpLink.click(() => {
                    Solovis.Site.HelpManager.showCustomHelpDialog({
                        html: "<p>If a report supports the use of data packs, this data pack will be used to help process the result.</p>"
                            + "<p>NOTE: Not all data sets support the use of data packs. Only core values present within the data pack can"
                            + " be used to process queries, and the remaining values will be filled in from the live database.</p>"
                    });
                });
                
                $("<span>").text(" : ").appendTo(contentDiv);

                let mountLink = $("<a>").text(activeDataPackCode).appendTo(contentDiv);

                Solovis.UI.PopupLinkPanel.onElementClick(
                    mountLink,
                    (e) => {
                        let links = [
                            {
                                label: "Data Pack Details",
                                click: () => {
                                    let detailDialog = new DataPackDetailDialog({
                                        mountCode: activeDataPackCode                                        
                                    });
                                    detailDialog.show();
                                }
                            }
                        ];

                        Solovis.UI.PopupLinkPanel.showLinks({
                            links: links,
                            offset: e
                        });
                    });

                this.container.html(contentDiv);
                this._bannerOptions.bannerElement.css("display", "block");
            }
            else {
                this.container.text("Live Database");
                this._bannerOptions.bannerElement.css("display", "none");
            }
        }
    }

}